/*
  Link-creation provenance tokens written to PinSettings.metadata.createdFrom at pin
  creation. Only clients that report a token can appear here — absence of provenance
  means "a client that doesn't report", never "created on web".
*/

const LINK_CREATION_SOURCES = {
  safari_extension: { label: 'Mobile Safari Extension' },
  keyboard: { label: 'Mobile Keyboard' },
  chrome_extension: { label: 'Chrome Extension' }
};

const getLinkCreationSourceLabel = token => LINK_CREATION_SOURCES[token]?.label || token;

// Parses an Opportunities.requiredLinkCreationSources comma string, dropping unknown tokens.
const parseRequiredLinkCreationSources = value =>
  (value || '')
    .split(',')
    .map(token => token.trim())
    .filter(token => token in LINK_CREATION_SOURCES);

const getRequiredLinkCreationSourceLabels = value => parseRequiredLinkCreationSources(value).map(getLinkCreationSourceLabel);

module.exports = {
  LINK_CREATION_SOURCES,
  getLinkCreationSourceLabel,
  parseRequiredLinkCreationSources,
  getRequiredLinkCreationSourceLabels
};
